// @ts-strict-ignore
import cloneDeep from "lodash/cloneDeep";

import { exhaustiveCheck } from "@lib/exhaustiveCheck";

import type { Language, InsertionWithOptions } from "../types";
import {
  conf as brazeFlavoredHtmlConf,
  language as brazeFlavoredHtmlLanguage,
} from "./brazeFlavoredHtmlWithLiquid";
import { conf as brazeFlavoredLiquidConf, language as brazeFlavoredLiquidLanguage } from "./brazeFlavoredLiquid";
import type { LanguageSettings, TokenProvider } from "./types";

const excludeTranslationTag = (tokenProvider: TokenProvider) => {
  const provider = cloneDeep(tokenProvider);
  provider.builtinTags = provider.builtinTags.filter((tag) => tag !== "translation" && tag !== "endtranslation");
  return provider;
};

export const useLanguageSettings = () => {
  const getLanguageSettings = (
    editorLanguage: Language,
    insertionWithOptions: InsertionWithOptions
  ): LanguageSettings => {
    switch (editorLanguage) {
      case "html":
        return {
          tokenProvider: insertionWithOptions.translation
            ? brazeFlavoredHtmlLanguage
            : excludeTranslationTag(brazeFlavoredHtmlLanguage),
          languageConfig: brazeFlavoredHtmlConf,
        };
      case "liquid":
      case "plaintext":
        return {
          tokenProvider: insertionWithOptions.translation
            ? brazeFlavoredLiquidLanguage
            : excludeTranslationTag(brazeFlavoredLiquidLanguage),
          languageConfig: brazeFlavoredLiquidConf,
        };
      default:
        exhaustiveCheck(editorLanguage);
    }
  };

  return {
    getLanguageSettings,
  };
};
